import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IClinicToClinicCreateToPost, IClinicToClinicToNumberPostBody } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useLoaderActions } from "@/app/hooks/useLoaderActions";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useRouter } from "@/app/hooks/useRouter";
import { useNavigate } from "react-router";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useCreateTransferOrderAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { enable, disable } = useLoaderActions("isPOCreateInProgress");
  const { getRouteKey } = useRouter();
  const navigate = useNavigate();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (filterProps: IClinicToClinicToNumberPostBody) => {
      enable();
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: IClinicToClinicToNumberPostBody = await axios
          .post(INVENTORY_MODULE?.CREATE_TRANSFER_ORDER?.baseURL ?? "", filterProps, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IClinicToClinicCreateToPost>) => {
            disable();
            if (res.data.status === true) {
              navigate(getRouteKey("TRANSFER_ORDERS", "url"));
              toast.success(res.data.message);
              return res.data.data;
            } else {
              toast.error(res.data.message);
              return null;
            }
          })
          .catch((e: AxiosError) => {
            toast.error(e.message);
            sendCurl(e.config["curlCommand"]);
            disable();
            captureError(e)
            return null;
          });
        return response;
      } catch (e: any) {
        disable();
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
